<template>
  <div class="results-total">
    <div v-if="results && results.record" class="table-results">

      <div class="cost-title">
        <Button outlined
                :styles="{ 'border-radius': '6px', 'min-width': '45px' }"
                @click="openGroupSupplementTotals('Supplement')">
          <span class="green-btn-color-text">Σ  Supplement</span>
          <Img class="ml-2" :src="getImgWithExt(['icons', 'chevron-right', 'svg'])" alt="chevron right" style="width: 10px; height: 10px" />
        </Button>
      </div>

      <div class="table-cell">
        <span class="label">All Supplements:</span>
        <span class="value">${{results.record.totalPrice ? results.record.totalPrice.toFixed(2) : '0'}}</span>
      </div>
      <div class="table-cell">
        <span class="label">Daily:</span>
        <span class="value">${{results.record.dailyPrice ? results.record.dailyPrice.toFixed(2) : '0'}}</span>
      </div>
      <div class="table-cell">
        <span class="label">Weekly:</span>
        <span class="value">${{results.record.weeklyPrice ? results.record.weeklyPrice.toFixed(2) : '0'}}</span>
      </div>
      <div class="table-cell">
        <span class="label">Monthly:</span>
        <span class="value">${{results.record.monthlyPrice ? results.record.monthlyPrice.toFixed(2) : '0'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Table from '@/components/elements/Table'
import Number from '@/mixins/Number'
import Image from '@/mixins/Image'
import Button from '@/components/elements/Button'
import { mapMutations } from 'vuex'
import { trackEvent } from '@/utils/analytics'

export default {
  name: 'results-total',
  components: { Table, Button },
  mixins: [Number, Image],
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    openGroupSupplementTotals (type) {
      trackEvent(this, 'group_supplement_totals', 'Results', 'Supplements Total')

      this.TOGGLE_DIALOG({ name: 'resultGroupSupplementTotals', title: `${type} Totals`, isOpen: true, data: { type } })
    },
  },
  computed: {
    results () {
      return this.$store.state?.results?.results
    }
  }
}
</script>

<style scoped lang="scss">
.results-total {
  height: 60px;
  background-color: #fff;
  border-radius: 16px;
  margin-top: 22px;

  .table-results {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0px 7px 0px 29px;
  }

  .table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 22px;

    &:not(:last-child) {
      border-right: 1px solid #EDF2F7;
    }
  }
  .label {
    font-weight: 600;
    font-size: 12px;
    color: #718096;
  }
  .value {
    font-weight: 600;
    font-size: 12px;
    color: #425466;
    padding-left: 5px;
  }
}

.cost-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  color: #101225;
  margin-right: auto;

  .button {
    ::v-deep .v-btn {
      border: none;
      background-color: #EBF2FA;
    }
  }
}
</style>
